import {
	apiGet,
	apiPost,
	apiPut,
	apiPostBlob
} from './api';

// 查询店铺详情
export const getStoreInfoDetail = (data) => {
	return apiGet('/ecommerce/store/getAccountStoreInfo', data);
};

// 查询店铺详情
// export const getStoreInfoDetail = (data) => {
// 	return apiGet('/ecommerce/store/getStoreInfoDetail', data);
// };

// 新增/修改店铺信息
export const cuStoreInfo = (data) => {
	return apiPost('/ecommerce/store/cuStoreInfo', data);
}

// 查询店铺类别
export const getStoreTypeList = (data) => {
	return apiPost('/ecommerce/store/queryStoreTypePage', data);
}
// 查询店铺的订单信息
export const order = (data) => {
	return apiPost('/ecommerce/order/query', data);
}

// 订单已备货
export const goodsReady = (orderId) => {
	return apiPut(`/ecommerce/order/goodsReady?orderId=${orderId}`);
}

// 订单已收货
export const goodsReceived = (orderId) => {
	return apiPut(`/ecommerce/order/goodsReceived?orderId=${orderId}`);
}

// 查询店铺黑名单用户
export const queryStoreBlockUser = (data) => {
	return apiPost('/ecommerce/store/queryStoreBlockUser', data);
}

// 拉黑/取消拉黑用户
export const blockOrCancelBlock = (memberUserId) => {
	return apiPut(`/ecommerce/store/blockOrCancelBlock?memberUserId=${memberUserId}`);
}

// 导出订单
export const exportOrder = (data) => {
	return apiPostBlob('/ecommerce/order/export', data);
}
